import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useLogOut from '../../Hooks/useLogOut';
import { PROFILE_URL } from '../../constents/placeholder';
import { useSelector } from 'react-redux';
import { ShowProfileContext } from '../../Contexts/showProfileContext';

const LoggedIn = () => {
    const { showProfile } = useContext(ShowProfileContext)
    const [showBox, setShowBox] = useState(false);
    const Navigate = useNavigate();
    const [loading, error, logoutFunction] = useLogOut();
    const profileUrl = useSelector((store) => store?.user?.profile_url);
    const usersName = useSelector((store) => store?.user?.first_name);
    const message = "Welcome back!";
    const userSortID = useSelector((store) => store?.user?.short_cnid);
    // const userSortID = "hf--0";

    return (
        <div
            className='relative'
        >
            <div className='flex items-center gap-2 p-1 border-[0.1rem] rounded-full pr-4'>
                <img src={profileUrl || PROFILE_URL}
                    onClick={showProfile}
                    className='w-10 h-10 rounded-full cursor-pointer '
                    alt="profile" />
                <div
                    onClick={() => setShowBox(pre => !pre)}
                    onBlur={() => setShowBox(false)}
                >
                    <h2>{usersName}</h2>
                    <p className='text-[0.92rem] font-semibold text-black'>{userSortID}</p>
                </div>
            </div>

            {/* Show only on small screens */}
            {showBox && (
                <div className='absolute right-0 z-10 flex flex-col gap-1 p-2 bg-white rounded-md shadow-md cursor-pointer top-12 sm:hidden'>
                    <span onClick={() => logoutFunction()} className='px-4 py-2 text-sm text-white transition-all duration-200 bg-red-600 rounded-md shadow-sm'>
                        Logout
                    </span>
                </div>
            )}
        </div>
    )
}

export default LoggedIn;